import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/apiservice/apiservice.service';
import { ConfigService } from '../../../services/config/config.service';
import { Observable } from 'rxjs';

export class HldMaintenance {
  subFieldTag: string;
  description: string;
  value: string;
  editable: boolean;
  isLibraryField: boolean;
  isCallNumber: boolean;
}

export class HoldingResponse {
  bibData: BibData;
  libraries: HoldingLibrary[];
  holdings: Holding[];
  newHolding: Holding;
}

export class Holding {
  holdingId: number;
  library: HoldingLibrary;
  callNumber: string;
  hldDetails: HldMaintenance[];
  hldContent: string;
}

export class BibData {
  agControlId: string;
  libraryDBPoolKey: number;
  title: string;
  author: string;
  publisher: string;
  date: string;
  format: string;
}

export class HoldingLibrary {
  libraryProfileKey: number;
  name: string;
  libCode: string;
}

@Injectable()
export class StaffFullRecordService {
  constructor(
    private _apiService: ApiService,
    private _configService: ConfigService,
  ) {}

  copyCatalog(libraryDBPoolKey: number, agControlId: string, data: Holding): Observable<void> {
    const url = this._configService.searchApi + `/bib/copy/${libraryDBPoolKey}/${agControlId}`;
    return this._apiService.post(url, data);
  }

  newHolding(libraryDBPoolKey: number, agControlId: string): Observable<HoldingResponse> {
    const url = this._configService.searchApi + `/bib/copy/${libraryDBPoolKey}/${agControlId}`;
    return this._apiService.get(url);
  }

  modifyExistingRequest(data): Observable<any> {
    const url = this._configService.agApi + '/illrequest/ModifyExistingRequest';
    return this._apiService.post(url, data);
  }

  currentLocations(agControlId: string, libraryDBPoolKey: number): Observable<HoldingResponse> {
    const url = this._configService.searchApi + `/bib/holdings/${libraryDBPoolKey}/${agControlId}`;
    return this._apiService.get(url + '');
  }

  addLocation(libraryDBPoolKey: number, agControlId: string, data: Holding): Observable<void> {
    const url = this._configService.searchApi + `/bib/holdings/${libraryDBPoolKey}/${agControlId}`;
    return this._apiService.post(url, data);
  }

  updateLocation(libraryDBPoolKey: number, agControlId: string, data: Holding): Observable<void> {
    const url = this._configService.searchApi + `/bib/holdings/${libraryDBPoolKey}/${agControlId}`;
    return this._apiService.put(url, data);
  }

  deleteLocation(
    libraryDBPoolKey: number,
    agControlId: string,
    holdingId: number,
  ): Observable<void> {
    const url =
      this._configService.searchApi + `/bib/holdings/${libraryDBPoolKey}?holdingId=${holdingId}`;
    return this._apiService.delete(url);
  }
}
